
import DataBinder from "./DataBinder.js"
import SwapPage from "./SwapPage.js"
export default class Router {
    constructor(app, controllers, defaultController) {
        this.app = app;
        this.controllers = controllers;
        this.defaultController = defaultController;
        this.lastPage = null;
        this.onRoute = function (path, pageId) { };
        window.addEventListener('hashchange', () => {
            this.route();
        }, false);
    }
    navigate(path, model) {

        //back button is not needed from browser any more
        //hardware back button is covered by cordova

        //   if (history.pushState) {
        //       history.pushState(null, null, "#" + path);
        //   } else {
        //       window.location.hash = path; //location.hash = triggers addEventListener('hashchange') and double routes
        //   }

        //this changes the URL hash without triggering hashchange
        if (history.replaceState) {
            history.replaceState(null, null, "#" + path);
        }

        this.route(path, model);
    }
    route(path, model) {
        const lastPageId = this.lastPage;
        if (!path) path = window.location.hash.substr(1); //.substr(1) remove hash
        if (!model) model = this.app;

        //get page
        path = path.replace(/^\/+/g, ''); //remove leading slash
        let pageId = path.split("/")[0];

        //log
        //TrackPage("IAP");

        //map pageId to controller if needed
        if (!pageId) pageId = "MainMenu";

        //trigger last controller for clean up
        const lastController = this.getController(lastPageId);
        if (lastController && lastController.hide) lastController.hide(path, model);

        //trigger controller show
        const controller = this.getController(pageId);
        if (controller && controller.show) controller.show(path, model);

        this.lastPage = pageId;

        if (this.onRoute) this.onRoute(path, pageId);
    }
    getController(controllerId) {
        let controller = this.controllers[controllerId];
        return controller || this.defaultController;
    }
}